import first from "lodash/fp/first";
import last from "lodash/fp/last";
import values from "lodash/fp/values";
import isString from "lodash/fp/isString";
import isNil from "lodash/fp/isNil";
import mapConstants from "../../core/mapConstants";
import constants from "../../core/constants";
import moment from "moment";

class Mapie {
  constructor() {
    this.defaultPolylineOptions = {
      strokeColor: mapConstants.comingDirectionColor,
    };
    this.calculateDistance = (originVal, destinationVal) => {
      const originLat = isString(originVal)
        ? first(originVal.split(","))
        : first(originVal);
      const originLng = isString(originVal)
        ? last(originVal.split(","))
        : last(originVal);
      const origin = new window.google.maps.LatLng(originLat, originLng);

      const destinationLat = isString(destinationVal)
        ? first(destinationVal.split(","))
        : first(destinationVal);
      const destinationLng = isString(destinationVal)
        ? last(destinationVal.split(","))
        : last(destinationVal);
      const destination = new window.google.maps.LatLng(
        destinationLat,
        destinationLng
      );
      const service = new window.google.maps.DistanceMatrixService();

      return new Promise((resolve, reject) => {
        service.getDistanceMatrix(
          {
            origins: [origin],
            destinations: [destination],
            travelMode: "DRIVING",
          },
          (response, status) => {
            if (status === "OK") resolve(response);
            else reject(status);
          }
        );
      });
    };
  }

  formatPoint(point) {
    return {
      location: {
        lat: last(point.loc.coordinates),
        lng: first(point.loc.coordinates),
      },
      stopover: true,
    };
  }

  pointArray(point) {
    point.location = [point.loc.coordinates[1], point.loc.coordinates[0]];
    return point;
  }

  formatPolygon(point) {
    const flatPoints = first(first(point.loc.coordinates));
    return flatPoints.map((p) => [...p.reverse()]);
  }

  formatPaths(path) {
    const flatPoints = first(path);
    return flatPoints.map((p) => [...p.reverse()]);
  }

  formatPointData(point) {
    return {
      location: [last(point.loc.coordinates), first(point.loc.coordinates)],
      name: `${point.name} Station`,
      address: point.address,
      _id: point._id,
    };
  }

  pointSrt(point) {
    return point && point.location
      ? `${point.location.lat},${point.location.lng}`
      : null;
  }

  getPolyOptionsWithDefaults(options) {
    return Object.assign({}, this.defaultPolylineOptions, options);
  }

  getDurationDistance(data) {
    const rowData = first(data.rows);
    const element = first(rowData.elements);
    const distance = element.distance;
    const duration = element.duration;

    return { distance, duration };
  }

  addInfoElement(element) {
    const mapWrapper = first(document.getElementsByClassName("gm-style"));
    if (!isNil(mapWrapper)) mapWrapper.appendChild(element);
  }

  addDistanceLayer(distanceText, mode = "") {
    const element = document.createElement("div");
    const wrapper = document.createElement("div");
    const modeClasses = mode === "edit" ? "--modified" : "--original";
    const wrapperClassName = `${mapConstants.distanceLayerWrapperClass} ${modeClasses}`;

    element.innerHTML = distanceText;
    wrapper.className = wrapperClassName;
    wrapper.appendChild(element);

    this.addInfoElement(wrapper);
  }

  addInfoLayer(options) {
    const message = this.getDelayMsg(options);

    if (!message) return;

    const statusClass = options.isLate ? "warn" : "success";
    const wrapperClassName = `${mapConstants.infoLayerWrapperClass} ${statusClass}`;
    const className = mapConstants.infoLayerClass;

    const element = document.createElement("div");
    const wrapper = document.createElement("div");

    element.className = className;
    element.innerHTML = message;

    wrapper.className = wrapperClassName;
    wrapper.appendChild(element);

    this.addInfoElement(wrapper);
  }

  getTimeFromExpected(expected) {
    const hours = expected.hours() * 60 * 60 * 1000;
    const mins = expected.minutes() * 60 * 1000;
    const seconds = expected.seconds() * 1000;
    const milliseconds = expected.milliseconds();

    return hours + mins + seconds + milliseconds;
  }

  getTimeDelay(actual, expected) {
    const actualUinx = this.getTimeFromExpected(moment(actual));
    const expectedUinx = this.getTimeFromExpected(moment(expected));

    const difference = actualUinx - expectedUinx;
    const diffDuration = moment.duration(difference);
    const mins = diffDuration.asMinutes();
    const isLate = mins > 0;

    return { mins: Math.abs(mins), isLate };
  }

  getDelayMsg(options) {
    const isComing = options.coming;
    const arrived = options.hasArrived;
    const mins = Math.round(options.mins);
    const isLate = options.isLate;
    const content = arrived ? "was" : isComing ? "will be" : "is";
    let message = "Bus ";

    if (isLate) {
      message += `${content} late ${mins} mins`;
    } else {
      message += `${content} early ${mins} mins`;
    }

    return message;
  }

  parseGoogleDuration(durationDistance) {
    const durationVal = durationDistance.duration
      ? durationDistance.duration.value
      : null;
    if (durationVal) {
      const actual = moment().add(durationVal);

      return actual;
    }

    return null;
  }

  getDistanceFromMap(map) {
    const directionsRenderers = first(values(map.directionsRenderers));

    if (isNil(directionsRenderers) || isNil(directionsRenderers.directions)) {
      return;
    }

    const legs = directionsRenderers.directions.routes[0].legs;
    const distanceSum = legs.reduce(
      (acc, current) => acc + current.distance.value,
      0
    );
    const distance = Math.round(distanceSum / constants.toKiloMeters);
    return `${distance} km`;
  }

  getGodsViewStyle() {
    return [
      {
        featureType: "administrative.land_parcel",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "administrative.neighborhood",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels.text",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "labels.text",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
    ];
  }
}

export default Mapie;



// WEBPACK FOOTER //
// ./src/services/mapie/mapie.service.js